import type {Density} from './types'

export const columnGap = (el: Element | null) => {
  if (!el) return 0
  const computedStyle = window.getComputedStyle(el)
  if (computedStyle?.columnGap) return parseInt(computedStyle.columnGap, 10) // e.g., '16px' => 16
  return 0
}

const calculateItemLayoutWidth = (item: HTMLElement, gap: number) => {
  return item.offsetWidth + gap * 2
}

/**
 * Calculate the offset width of a single item within its container.
 * Handles gap calculation internally.
 */
export const getItemWidth = (item: HTMLElement, container: HTMLElement): number => {
  const gap = columnGap(container)
  return calculateItemLayoutWidth(item, gap)
}

/**
 * Batch calculate offset widths for multiple items within their container.
 * Reads container gap once via getComputedStyle; per-item reads use only
 * offsetWidth (no per-item getComputedStyle).
 */
export const batchGetItemWidths = (
  items: Array<{key: string; el: HTMLElement}>,
  container: HTMLElement,
): Map<string, number | undefined> => {
  const widths = new Map<string, number | undefined>()
  if (items.length === 0) return widths

  // Read gap once for all items
  const gap = columnGap(container)

  // Batch all offsetWidth reads together
  for (const {key, el} of items) {
    widths.set(key, calculateItemLayoutWidth(el, gap))
  }

  return widths
}

export const gapFromDensity = (density?: Density) => {
  if (density === 'condensed') return 'var(--base-size-4)'
  if (density === 'spacious') return 'var(--base-size-16)'
  if (density === 'none') return 0
  return 'var(--base-size-8)'
}
